import * as forms from '@/libraries/forms/forms'
import { CameraUpload } from '@/libraries/model/model'
import { store } from '@/store/store'

var URL = require('url-parse')

const fields = [
  new forms.FormField({
    type: forms.FormFieldType.TEXT,
    identifier: 'name',
    label: 'Name',
    placeholder: 'New Camera',
    defaultValue: 'New Camera',
  }),
  new forms.FormField({
    type: forms.FormFieldType.URL,
    identifier: 'url',
    label: 'URL',
    placeholder: 'rtsp://',
  }),
]

const rules = [
  new forms.DuplicateRule(),
  new forms.SequentialValueRule(),
  new forms.FormTemplateRule('Convert To DB Form', function (submission) {
    const domainUUID = store.getters.currentDomainUUID

    const url = new URL(submission.fields.url, {}, true)

    const camera = new CameraUpload({
      domainUUID,
      name: submission.fields.name,
      uuid: submission.fields.uuid, // Plan is that empty UUID means "create" otherwise, pass back the inital one.
      protocol: url.protocol,
      host: url.hostname,
      port: url.port,
      username: url.username,
      password: url.password,
      path: url.pathname,
    })
    return camera
  }), // ,
  // new forms.EnsureArrayRule()
]

const template = new forms.FormTemplate('Advanced Settings', rules)

export const form = new forms.Form('Other', fields, template)
